(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var form = document.querySelector('.cart-page__form');
    if (!form) return;

    var pending = null;
    var cartTotal = document.querySelector('.cart-page__total-price');
    var cartCount = document.querySelector('.header__cart-count');

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function recalcTotal() {
      var total = 0;
      var count = 0;
      var items = form.querySelectorAll('.cart-page__item');
      items.forEach(function (item) {
        var qty = parseInt(item.querySelector('.cart-page__qty-input').value, 10) || 0;
        var price = parseInt(item.dataset.price, 10);
        total += price * qty;
        count += qty;
      });
      cartTotal.textContent = formatMoney(total);
      if (cartCount) cartCount.textContent = count;
    }

    function sendUpdate(key, qty, item) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (qty === 0) {
          item.remove();
          if (cart.item_count === 0) location.reload();
        }
      });
    }

    form.addEventListener('click', function (e) {
      var btn = e.target.closest('.cart-page__qty-btn');
      if (!btn) return;

      var item = btn.closest('.cart-page__item');
      var input = item.querySelector('.cart-page__qty-input');
      var val = parseInt(input.value, 10) || 0;
      var key = item.dataset.key;

      if (btn.dataset.action === 'increase') {
        val = val + 1;
      } else if (btn.dataset.action === 'decrease' && val > 0) {
        val = val - 1;
      } else {
        return;
      }

      input.value = val;
      recalcTotal();

      if (pending) clearTimeout(pending);
      pending = setTimeout(function () {
        sendUpdate(key, val, item);
        pending = null;
      }, 300);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"]) return;
  try {
    
  var form = document.querySelector('.contact form');
  if (form) {
    form.addEventListener('submit', function() {
      var btn = form.querySelector('.btn');
      if (btn) btn.classList.add('btn--loading');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.faq__contact-email').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var email = btn.getAttribute('data-email');
      var textEl = btn.querySelector('.faq__contact-email-text');
      navigator.clipboard.writeText(email).then(function() {
        textEl.textContent = 'Copied!';
        setTimeout(function() {
          textEl.textContent = email;
        }, 1500);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  var logo = document.querySelector('.hero__logo');
  var anim = document.getElementById('logo-shine-anim');
  if (logo && anim) {
    logo.addEventListener('mouseenter', function() {
      anim.beginElement();
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-product"] && !Shopify.designMode) return;
  try {
    
  /* Loading state on form submit */
  var form = document.querySelector('.homepage-product form[action*="/cart/add"]');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = form.querySelector('.homepage-product__add-btn');
      if (btn) btn.classList.add('btn--loading');

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin'
      })
      .then(function(r) {
        if (!r.ok) throw new Error(r.status);
        if (btn) btn.classList.remove('btn--loading');
        if (window.cartDrawer) window.cartDrawer.open();
      })
      .catch(function() {
        if (btn) btn.classList.remove('btn--loading');
        form.submit();
      });
    });
  }

  /* Clear loading state when page is restored from bfcache (browser back button) */
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) {
      var btn = document.querySelector('.homepage-product__add-btn');
      if (btn) btn.classList.remove('btn--loading');
    }
  });

  /* Quantity buttons */
  document.querySelectorAll('.homepage-product__qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = this.parentElement.querySelector('.homepage-product__qty-input');
      var value = parseInt(input.value) || 1;
      if (this.dataset.action === 'increase') {
        input.value = value + 1;
      } else if (this.dataset.action === 'decrease' && value > 1) {
        input.value = value - 1;
      }
    });
  });

  /* Image carousel */
  (function() {
    var carousel = document.querySelector('.homepage-product__carousel');
    if (!carousel) return;

    var track = carousel.querySelector('.homepage-product__carousel-track');
    var slides = Array.from(carousel.querySelectorAll('.homepage-product__slide'));
    var prevBtn = carousel.querySelector('.homepage-product__carousel-btn--prev');
    var nextBtn = carousel.querySelector('.homepage-product__carousel-btn--next');
    var dots = carousel.querySelectorAll('.homepage-product__dot');
    var total = slides.length;

    if (total <= 1) return;

    /* Clone first and last slides for seamless wrapping */
    var firstClone = slides[0].cloneNode(true);
    var lastClone = slides[total - 1].cloneNode(true);
    firstClone.classList.add('homepage-product__slide--clone');
    lastClone.classList.add('homepage-product__slide--clone');

    /* Disable transition during setup so positioning is instant */
    track.style.transition = 'none';
    track.appendChild(firstClone);
    track.insertBefore(lastClone, track.firstChild);

    /* Position starts at 1 (real first slide, after prepended clone) */
    var pos = 1;
    var transitioning = false;
    track.style.transform = 'translateX(-' + (pos * 100) + '%)';
    track.offsetHeight; /* force reflow */
    track.style.transition = '';
    slides[0].classList.add('homepage-product__slide--active');

    function setPos(p, animate) {
      if (animate === false) {
        track.style.transition = 'none';
      }
      track.style.transform = 'translateX(-' + (p * 100) + '%)';
      if (animate === false) {
        track.offsetHeight; /* force reflow */
        track.style.transition = '';
      }
    }

    function updateActive(index) {
      /* Clear active from all including clones */
      track.querySelectorAll('.homepage-product__slide').forEach(function(s) {
        s.classList.remove('homepage-product__slide--active');
      });
      /* Real slide index (0-based) */
      var realIndex = ((index - 1) % total + total) % total;
      slides[realIndex].classList.add('homepage-product__slide--active');
      /* Also activate clone if it's visible */
      var allSlides = track.querySelectorAll('.homepage-product__slide');
      allSlides[index].classList.add('homepage-product__slide--active');
      dots.forEach(function(dot, i) {
        dot.classList.toggle('homepage-product__dot--active', i === realIndex);
      });
    }

    var safetyTimer = null;

    function goTo(newPos) {
      if (transitioning) return;
      transitioning = true;
      pos = newPos;
      updateActive(pos);
      setPos(pos, true);
      /* Safety fallback in case transitionend doesn't fire */
      clearTimeout(safetyTimer);
      safetyTimer = setTimeout(function() { transitioning = false; }, 600);
    }

    track.addEventListener('transitionend', function(e) {
      if (e.target !== track) return;
      clearTimeout(safetyTimer);
      /* Seamless jump when landing on a clone */
      var jumped = false;
      if (pos === 0) {
        pos = total;
        setPos(pos, false);
        jumped = true;
      } else if (pos === total + 1) {
        pos = 1;
        setPos(pos, false);
        jumped = true;
      }
      updateActive(pos);
      /* Small buffer after clone jump so next click doesn't expose the reset */
      if (jumped) {
        setTimeout(function() { transitioning = false; }, 60);
      } else {
        transitioning = false;
      }
    });

    prevBtn.addEventListener('click', function() { goTo(pos - 1); });
    nextBtn.addEventListener('click', function() { goTo(pos + 1); });

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var target = parseInt(this.dataset.index) + 1;
        if (target !== pos) goTo(target);
      });
    });

    /* Touch/swipe support */
    var startX = 0;
    var startY = 0;
    var diffX = 0;
    var diffY = 0;
    var viewport = carousel.querySelector('.homepage-product__carousel-viewport');

    viewport.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      diffX = 0;
      diffY = 0;
    }, { passive: true });

    viewport.addEventListener('touchmove', function(e) {
      diffX = e.touches[0].clientX - startX;
      diffY = e.touches[0].clientY - startY;
    }, { passive: true });

    viewport.addEventListener('touchend', function() {
      if (Math.abs(diffX) > 50 && Math.abs(diffX) > Math.abs(diffY) * 1.5) {
        goTo(diffX > 0 ? pos - 1 : pos + 1);
      }
    });
  })();

  (function() {
    var btn = document.querySelector('.homepage-product__guarantee');
    if (!btn) return;
    var overlay = document.createElement('div');
    overlay.className = 'homepage-product__guarantee-overlay';
    overlay.hidden = true;
    var detail = document.createElement('div');
    detail.className = 'homepage-product__guarantee-detail';
    detail.hidden = true;
    detail.innerHTML = '<button type="button" class="homepage-product__guarantee-close" aria-label="Close">&times;</button><h3>Not satisfied?</h3><p>We get it, it\'s not us it\'s you. First-time customers can request a full refund on one bottle of Not Drugs within 30 days of purchase. Just email <a href="mailto:hello@not-drugs.com">hello@not-drugs.com</a> with your name, order number, and a brief note about what didn\'t work. We reserve the right to limit this offer at our discretion to prevent abuse.</p>';
    document.body.appendChild(overlay);
    document.body.appendChild(detail);
    function toggle(show) {
      overlay.hidden = !show;
      detail.hidden = !show;
      btn.setAttribute('aria-expanded', String(show));
      document.body.style.overflow = show ? 'hidden' : '';
    }
    btn.addEventListener('click', function() { toggle(detail.hidden); });
    overlay.addEventListener('click', function() { toggle(false); });
    detail.querySelector('.homepage-product__guarantee-close').addEventListener('click', function() { toggle(false); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients"] && !Shopify.designMode) return;
  try {
    
(function(){
  var NS='http://www.w3.org/2000/svg',FG='var(--color-foreground)',FN='var(--font-heading--family),sans-serif';
  function sv(tag,a,p){var e=document.createElementNS(NS,tag);for(var k in a)e.setAttribute(k,a[k]);if(p)p.appendChild(e);return e;}
  var formulas={'l-cysteine':'C\u2083H\u2087NO\u2082S','vitamin-b6':'C\u2088H\u2081\u2081NO\u2083','vitamin-c':'C\u2086H\u2088O\u2086'};
  var data={'l-cysteine':{vb:'-16 -28 440 400',atoms:[[26.7,225.4,'S'],[196.9,290.5,'N'],[291.9,26.7,'O'],[380.2,222.3,'O']],hyd:[[26.7,225.4,-30,275],[196.9,290.5,140,340],[196.9,290.5,254,340],[380.2,222.3,438,268]]},'vitamin-b6':{vb:'3 13 440 400',atoms:[[23.8,184.2,'N'],[109.6,23.8,'O'],[443.4,187.5,'O'],[228.2,325,'O']],hyd:[[109.6,23.8,60,-35],[443.4,187.5,495,130],[228.2,325,228,400]]},'vitamin-c':{vb:'2 -1 440 400',atoms:[[21,90.5,'O'],[171,29.3,'O'],[314.3,88.4,'O'],[434.3,100.4,'O'],[211.2,313.3,'O'],[413.3,317.4,'O']],hyd:[[21,90.5,-25,150],[171,29.3,122,-27],[211.2,313.3,161,369],[413.3,317.4,450,385]]}};
  var tM=new Map();
  function clr(c){var t=tM.get(c);if(t){t.forEach(clearTimeout);tM.delete(c);}}
  function atm(c,id){var t=tM.get(c)||[];t.push(id);tM.set(c,t);}
  function onX(e){e.stopPropagation();collapse(this.closest('.ingredients__card'));}
  function rstDos(c,d){if(!d||d.dataset.ot==null)return;d.style.width=d.dataset.ow+'px';d.style.height=d.dataset.oh+'px';d.style.padding='0.25rem 0.875rem';d.style.fontSize='0.8125rem';d.style.letterSpacing='0.02em';d.removeEventListener('click',onX);var ot=d.dataset.ot;atm(c,setTimeout(function(){d.textContent=ot;d.style.width='';d.style.height='';d.style.padding='';d.style.fontSize='';d.style.letterSpacing='';delete d.dataset.ot;delete d.dataset.ow;delete d.dataset.oh;},550));}

  function expand(card,icon){
    if(card.classList.contains('is-expanded')){collapse(card);return;}
    if(card.dataset.busy)return;
    clr(card);card.classList.remove('is-collapsing');
    card.dataset.busy='1';
    var mol=icon.getAttribute('data-molecule'),s=icon.querySelector('svg');
    if(!s){delete card.dataset.busy;return;}
    card.style.height=card.offsetHeight+'px';
    var sub=card.querySelector('.ingredients__subtitle');
    if(sub){sub.dataset.origSub=sub.textContent;if(formulas[mol])sub.textContent=formulas[mol];}
    var dos=card.querySelector('.ingredients__dosage');
    if(dos){if(!dos.dataset.ot){dos.dataset.ot=dos.textContent;dos.dataset.ow=dos.offsetWidth;dos.dataset.oh=dos.offsetHeight;}dos.style.width=dos.offsetWidth+'px';dos.style.height=dos.offsetHeight+'px';void dos.offsetHeight;dos.style.width='2rem';dos.style.height='2rem';dos.style.padding='0';dos.style.fontSize='1.25rem';dos.style.letterSpacing='0';dos.textContent='\u00d7';dos.addEventListener('click',onX);}
    card.classList.add('is-fast-expand');
    card.classList.add('is-expanded');
    atm(card,setTimeout(function(){delete card.dataset.busy;},900));
    var d=data[mol];
    if(d){
      s.dataset.origVB=s.getAttribute('viewBox');s.setAttribute('viewBox',d.vb);
      atm(card,setTimeout(function(){
        d.atoms.forEach(function(a,i){var g=sv('g',{'class':'atom-label'},s);g.style.animationDelay=(i*0.15)+'s';sv('circle',{cx:a[0],cy:a[1],r:22,fill:'var(--color-accent)'},g);var t=sv('text',{x:a[0],y:a[1]+1,'text-anchor':'middle','dominant-baseline':'central',fill:'var(--color-background)','font-size':22,'font-weight':700,'font-family':FN},g);t.textContent=a[2];});
      },900));
      atm(card,setTimeout(function(){
        d.hyd.forEach(function(h,i){var dx=h[2]-h[0],dy=h[3]-h[1],ds=Math.sqrt(dx*dx+dy*dy),nx=dx/ds,ny=dy/ds;var ln=sv('line',{x1:h[0]+nx*28,y1:h[1]+ny*28,x2:h[2]-nx*17.5,y2:h[3]-ny*17.5,stroke:FG,'stroke-width':2,'class':'hydrogen-bond'},s);ln.style.animationDelay=(i*0.1)+'s';var g=sv('g',{'class':'hydrogen-label'},s);g.style.animationDelay=(i*0.1+0.15)+'s';sv('circle',{cx:h[2],cy:h[3],r:17.5,fill:'none',stroke:FG,'stroke-width':1.5},g);var t=sv('text',{x:h[2],y:h[3]+1,'text-anchor':'middle','dominant-baseline':'central',fill:FG,'font-size':17.5,'font-weight':600,'font-family':FN},g);t.textContent='H';});
      },1150));
    }
  }

  function collapse(card){
    if(!card||!card.classList.contains('is-expanded'))return;clr(card);delete card.dataset.busy;card.classList.remove('is-fast-expand');card.classList.add('is-collapsing');
    var s=card.querySelector('.ingredients__icon svg');
    if(s){
      s.querySelectorAll('.atom-label,.hydrogen-bond,.hydrogen-label').forEach(function(e){e.classList.add('is-fading-out');});
      if(s.dataset.origVB){s.setAttribute('viewBox',s.dataset.origVB);delete s.dataset.origVB;}
    }
    rstDos(card,card.querySelector('.ingredients__dosage'));
    var sub=card.querySelector('.ingredients__subtitle');
    if(sub&&sub.dataset.origSub){sub.textContent=sub.dataset.origSub;delete sub.dataset.origSub;}
    card.classList.remove('is-expanded');
    atm(card,setTimeout(function(){
      if(s)s.querySelectorAll('.atom-label,.hydrogen-bond,.hydrogen-label').forEach(function(e){e.remove();});
    },500));
    atm(card,setTimeout(function(){card.style.height='';card.classList.remove('is-collapsing');tM.delete(card);},1800));
  }

  var sec=document.querySelector('.ingredients[data-molecule-expand]');
  if(!sec||sec.dataset.moleculeExpand!=='true'){
    document.querySelectorAll('.ingredients__icon[data-molecule]').forEach(function(ic){ic.style.cursor='default';ic.removeAttribute('role');ic.removeAttribute('tabindex');ic.removeAttribute('aria-label');});
  } else {
    document.querySelectorAll('.ingredients__icon[data-molecule]').forEach(function(ic){
      ic.addEventListener('click',function(){expand(this.closest('.ingredients__card'),this);});
      ic.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();expand(this.closest('.ingredients__card'),this);}});
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape')document.querySelectorAll('.ingredients__card.is-expanded').forEach(function(c){collapse(c);});});
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var marquee = document.querySelector('.marquee');
    if (!marquee) return;
    var track = marquee.querySelector('.marquee__track');
    if (!track) return;

    /* Set duration dynamically: 50px per second */
    var pxPerSec = 55;
    var trackWidth = track.scrollWidth / 2;
    var duration = trackWidth / pxPerSec;
    track.style.animationDuration = duration + 's';
    track.style.animationPlayState = 'running';

    var anim = track.getAnimations()[0];
    if (!anim) return;

    var target = 1;
    var current = 1;
    var raf = null;

    function step() {
      current += (target - current) * 0.08;
      if (Math.abs(current - target) < 0.005) current = target;
      anim.playbackRate = current;
      if (current !== target) {
        raf = requestAnimationFrame(step);
      } else {
        raf = null;
      }
    }

    marquee.addEventListener('mouseenter', function () {
      target = 0;
      if (!raf) raf = requestAnimationFrame(step);
    });

    marquee.addEventListener('mouseleave', function () {
      target = 1;
      if (!raf) raf = requestAnimationFrame(step);
    });

    marquee.addEventListener('touchstart', function () {
      target = target === 0 ? 1 : 0;
      if (!raf) raf = requestAnimationFrame(step);
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /* Loading state on form submit */
  var form = document.querySelector('.product-page form[action*="/cart/add"]');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = form.querySelector('.product-page__add-btn');
      if (btn) btn.classList.add('btn--loading');

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin'
      })
      .then(function(r) {
        if (!r.ok) throw new Error(r.status);
        if (btn) btn.classList.remove('btn--loading');
        if (window.cartDrawer) window.cartDrawer.open();
      })
      .catch(function() {
        if (btn) btn.classList.remove('btn--loading');
        form.submit();
      });
    });
  }

  /* Quantity buttons */
  document.querySelectorAll('.product-page__qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = this.parentElement.querySelector('.product-page__qty-input');
      var value = parseInt(input.value) || 1;
      if (this.dataset.action === 'increase') {
        input.value = value + 1;
      } else if (this.dataset.action === 'decrease' && value > 1) {
        input.value = value - 1;
      }
    });
  });

  /* Sliding image carousel */
  (function() {
    var gallery = document.querySelector('.product-page__gallery');
    if (!gallery) return;

    var track = gallery.querySelector('.product-page__carousel-track');
    var slides = Array.from(gallery.querySelectorAll('.product-page__slide'));
    var prevBtn = gallery.querySelector('.product-page__arrow--prev');
    var nextBtn = gallery.querySelector('.product-page__arrow--next');
    var thumbs = gallery.querySelectorAll('.product-page__thumb');
    var total = slides.length;

    if (total <= 1) return;

    /* Clone first and last slides for seamless wrapping */
    var firstClone = slides[0].cloneNode(true);
    var lastClone = slides[total - 1].cloneNode(true);
    firstClone.classList.add('product-page__slide--clone');
    lastClone.classList.add('product-page__slide--clone');

    track.style.transition = 'none';
    track.appendChild(firstClone);
    track.insertBefore(lastClone, track.firstChild);

    var pos = 1;
    var transitioning = false;
    track.style.transform = 'translateX(-' + (pos * 100) + '%)';
    track.offsetHeight;
    track.style.transition = '';

    function setPos(p, animate) {
      if (animate === false) {
        track.style.transition = 'none';
      }
      track.style.transform = 'translateX(-' + (p * 100) + '%)';
      if (animate === false) {
        track.offsetHeight;
        track.style.transition = '';
      }
    }

    function updateActive(index) {
      track.querySelectorAll('.product-page__slide').forEach(function(s) {
        s.classList.remove('product-page__slide--active');
      });
      var realIndex = ((index - 1) % total + total) % total;
      slides[realIndex].classList.add('product-page__slide--active');
      var allSlides = track.querySelectorAll('.product-page__slide');
      allSlides[index].classList.add('product-page__slide--active');
      thumbs.forEach(function(t, i) {
        t.classList.toggle('product-page__thumb--active', i === realIndex);
      });
    }

    var safetyTimer = null;

    function goTo(newPos) {
      if (transitioning) return;
      transitioning = true;
      pos = newPos;
      updateActive(pos);
      setPos(pos, true);
      clearTimeout(safetyTimer);
      safetyTimer = setTimeout(function() { transitioning = false; }, 600);
    }

    track.addEventListener('transitionend', function(e) {
      if (e.target !== track) return;
      clearTimeout(safetyTimer);
      var jumped = false;
      if (pos === 0) {
        pos = total;
        setPos(pos, false);
        jumped = true;
      } else if (pos === total + 1) {
        pos = 1;
        setPos(pos, false);
        jumped = true;
      }
      updateActive(pos);
      if (jumped) {
        setTimeout(function() { transitioning = false; }, 60);
      } else {
        transitioning = false;
      }
    });

    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(pos - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(pos + 1); });

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var target = parseInt(this.dataset.index) + 1;
        if (target !== pos) goTo(target);
      });
    });

    /* Touch/swipe support */
    var startX = 0;
    var startY = 0;
    var diffX = 0;
    var diffY = 0;
    var viewport = gallery.querySelector('.product-page__carousel-viewport');

    viewport.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      diffX = 0;
      diffY = 0;
    }, { passive: true });

    viewport.addEventListener('touchmove', function(e) {
      diffX = e.touches[0].clientX - startX;
      diffY = e.touches[0].clientY - startY;
    }, { passive: true });

    viewport.addEventListener('touchend', function() {
      if (Math.abs(diffX) > 50 && Math.abs(diffX) > Math.abs(diffY) * 1.5) {
        goTo(diffX > 0 ? pos - 1 : pos + 1);
      }
    });
  })();

  /* Clear loading state when page is restored from bfcache (browser back button) */
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) {
      var btn = document.querySelector('.product-page__add-btn');
      if (btn) btn.classList.remove('btn--loading');
    }
  });

  (function() {
    var btn = document.querySelector('.product-page__guarantee');
    if (!btn) return;
    var overlay = document.createElement('div');
    overlay.className = 'product-page__guarantee-overlay';
    overlay.hidden = true;
    var detail = document.createElement('div');
    detail.className = 'product-page__guarantee-detail';
    detail.hidden = true;
    detail.innerHTML = '<button type="button" class="product-page__guarantee-close" aria-label="Close">&times;</button><h3>Not satisfied?</h3><p>We get it, it\'s not us it\'s you. First-time customers can request a full refund on one bottle of Not Drugs within 30 days of purchase. Just email <a href="mailto:hello@not-drugs.com">hello@not-drugs.com</a> with your name, order number, and a brief note about what didn\'t work. We reserve the right to limit this offer at our discretion to prevent abuse.</p>';
    document.body.appendChild(overlay);
    document.body.appendChild(detail);
    function toggle(show) {
      overlay.hidden = !show;
      detail.hidden = !show;
      btn.setAttribute('aria-expanded', String(show));
      document.body.style.overflow = show ? 'hidden' : '';
    }
    btn.addEventListener('click', function() { toggle(detail.hidden); });
    overlay.addEventListener('click', function() { toggle(false); });
    detail.querySelector('.product-page__guarantee-close').addEventListener('click', function() { toggle(false); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["survey"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.survey__form').forEach(function (form) {
    // Fires only after the browser's own validation passes. Fold the panel
    // shut and show the spinner while the request is in flight; Shopify then
    // redirects back to this page, which renders the thank-you state.
    form.addEventListener('submit', function () {
      form.classList.add('is-sending');
      var button = form.querySelector('.survey__submit .btn');
      if (button) button.setAttribute('aria-disabled', 'true');

      // Bring the top of the survey back into view (below the sticky header)
      // so the spinner card is what the visitor sees while it sends.
      var survey = form.closest('.survey') || form;
      var header = document.querySelector('.shopify-section-group-header-group');
      var offset = (header ? header.getBoundingClientRect().height : 0) + 16;
      var top = survey.getBoundingClientRect().top + window.scrollY - offset;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(top, 0), behavior: reduce ? 'auto' : 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.testimonials');
    if (!section) return;

    var slides = section.querySelectorAll('.testimonials__slide');
    var dots = section.querySelectorAll('.testimonials__dot');
    if (slides.length <= 1) return;

    var current = 0;
    var timer = null;
    var transitioning = false;
    var MS_PER_WORD = 275;
    var BASE_DELAY = 2000;
    var FADE_DURATION = 600;

    /* Set carousel height to tallest slide so it never resizes */
    function setCarouselHeight() {
      var carousel = section.querySelector('.testimonials__carousel');
      carousel.style.height = 'auto';
      var maxH = 0;
      slides.forEach(function(s) {
        s.style.position = 'relative';
        s.style.opacity = '0';
        var h = s.offsetHeight;
        if (h > maxH) maxH = h;
        s.style.position = '';
        s.style.opacity = '';
      });
      carousel.style.height = maxH + 'px';
    }

    setCarouselHeight();
    window.addEventListener('resize', setCarouselHeight);

    function getReadTime(index) {
      var quote = slides[index].querySelector('.testimonials__quote');
      var words = quote ? quote.textContent.trim().split(/\s+/).length : 20;
      return BASE_DELAY + (words * MS_PER_WORD);
    }

    function goTo(index) {
      if (transitioning || index === current) return;
      transitioning = true;

      /* Fade out current, fade in new simultaneously */
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
      }

      current = index;
      slides[current].classList.add('is-active');
      slides[current].setAttribute('aria-hidden', 'false');
      if (dots[current]) {
        dots[current].classList.add('is-active');
        dots[current].setAttribute('aria-selected', 'true');
      }

      setTimeout(function () {
        transitioning = false;
      }, FADE_DURATION);
    }

    function next() {
      goTo((current + 1) % slides.length);
    }

    function startTimer() {
      stopTimer();
      timer = setTimeout(function advance() {
        next();
        timer = setTimeout(advance, getReadTime(current));
      }, getReadTime(current));
    }

    function stopTimer() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    }

    /* Dot click handlers */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(this.getAttribute('data-dot-index'), 10);
        if (index !== current) {
          goTo(index);
          startTimer();
        }
      });
    });

    /* Pause on hover */
    var carousel = section.querySelector('.testimonials__carousel');
    if (carousel) {
      carousel.addEventListener('mouseenter', stopTimer);
      carousel.addEventListener('mouseleave', startTimer);
    }

    /* Touch/swipe support */
    var startX = 0;
    var diffX = 0;
    var carouselEl = carousel || section;

    carouselEl.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      diffX = 0;
      stopTimer();
    }, { passive: true });

    carouselEl.addEventListener('touchmove', function (e) {
      diffX = e.touches[0].clientX - startX;
    }, { passive: true });

    carouselEl.addEventListener('touchend', function () {
      if (Math.abs(diffX) > 40) {
        var target = diffX > 0
          ? (current - 1 + slides.length) % slides.length
          : (current + 1) % slides.length;
        goTo(target);
      }
      startTimer();
    });

    startTimer();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-us"] && !Shopify.designMode) return;
  try {
    
  var comparisons = [
    'a cup of coffee',
    'a cup of coffee',
    'a cup of coffee',
    'a cup of coffee',
    'a cup of coffee',
    'a cup of coffee',
    'a cup of coffee',
    'a cup of coffee',
    'a cup of coffee',
    'a hat'
  ];
  function rollComparison() {
    var el = document.querySelector('.price-compare');
    if (el) el.textContent = comparisons[Math.floor(Math.random() * comparisons.length)];
  }
  rollComparison();

  /* Smooth accordion animation */
  document.querySelectorAll('.why-us__item').forEach(function(details) {
    var summary = details.querySelector('.why-us__question');
    var answer = details.querySelector('.why-us__answer');
    if (!summary || !answer) return;
    var animating = false;

    summary.addEventListener('click', function(e) {
      e.preventDefault();
      if (animating) return;

      if (details.open) {
        /* Close */
        animating = true;
        var h = answer.scrollHeight;
        var anim = answer.animate(
          [{ height: h + 'px' }, { height: '0px' }],
          { duration: 300, easing: 'ease' }
        );
        anim.onfinish = function() {
          details.open = false;
          answer.style.height = '0';
          animating = false;
        };
      } else {
        /* Open */
        rollComparison();
        details.open = true;
        animating = true;
        var targetH = answer.scrollHeight;
        answer.style.height = '0';
        var anim = answer.animate(
          [{ height: '0px' }, { height: targetH + 'px' }],
          { duration: 300, easing: 'ease' }
        );
        anim.onfinish = function() {
          answer.style.height = 'auto';
          animating = false;
        };
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
